import { PERMISSIONS } from "@/services/permission.js"
import { FEATURE_SETS } from "@/services/featureSet.js"

// Tagesmeldungen: the days the app's users sent to the site management ("An Bauleitung senden"). Either
// project scope opens the pages; which Tagesmeldungen somebody sees, and may change, the backend decides
// per record by its project, as for the reports they become.
//
// The whole feature is the DAY_SUBMISSIONS feature-set, which the backend enforces on `/day-submission/**`
// (403 FEATURE_NOT_ENTITLED), so both routes carry `requiresFeatureSet` like the other add-ons' routes.
// Until its release the upsell page `featureSetGuard` sends a workspace without it to says it cannot be
// booked yet, rather than offering it.
const VIEW = [PERMISSIONS.VIEW_ASSIGNED_PROJECT_DAY_SUBMISSION, PERMISSIONS.VIEW_FOREIGN_PROJECT_DAY_SUBMISSION]

export default [
  {
    path: "/daysubmission/list",
    name: "DaySubmissionOverview",
    component: () => import("@/views/daysubmission/DaySubmissionOverview.vue"),
    meta: {
      title: "nav.daysubmission",
      requiresAuth: true,
      requiresPermissions: VIEW,
      requiresFeatureSet: FEATURE_SETS.DAY_SUBMISSIONS,
    },
  },
  {
    path: "/daysubmission/:daySubmissionId",
    name: "DaySubmissionDetail",
    component: () => import("@/views/daysubmission/DaySubmissionDetail.vue"),
    props: true,
    meta: {
      title: "nav.daysubmission",
      requiresAuth: true,
      requiresPermissions: VIEW,
      requiresFeatureSet: FEATURE_SETS.DAY_SUBMISSIONS,
    },
  },
]
